import { CardCollectionIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../Translations';

interface Props {
  kind: TPlainTextKey;
}

function NoProgramsInTab({ kind }: Props) {
  return (
    <div className="mt-5 flex w-full flex-col items-center justify-center border border-gray-500 p-[16px]">
      <CardCollectionIcon color="black" className="flex w-full justify-center" size="2xl" />
      <Typography variant="subtitleSmall" fontWeight="semibold" color="black">
        <T kind={kind} />
      </Typography>
    </div>
  );
}

export default observer(NoProgramsInTab);
